import React from 'react';
import { X, Check } from 'lucide-react';
export function WhatIsItSection() {
  return <section className="py-20 bg-brand-sand" data-id="element-229">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mb-12 text-center" data-id="element-231">
          Qué es el Arsenal del Nutri
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-232">
          <div className="space-y-4" data-id="element-233">
            {['No es un curso con videos que nunca terminás de ver.', 'No es un manual académico lleno de teoría que ya sabés.', 'No es un ebook con recetas genéricas que encontrás gratis en Instagram.'].map((text, i) => <div key={i} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-234">
                <X className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-235" />
                <p className="text-gray-600" data-id="element-236">{text}</p>
              </div>)}
          </div>

          <div className="bg-brand-teal text-white p-8 rounded-xl shadow-lg" data-id="element-237">
            <div className="flex items-start gap-4 mb-6" data-id="element-238">
              <Check className="w-8 h-8 text-brand-accent flex-shrink-0" data-id="element-239" />
              <p className="text-xl font-medium leading-relaxed" data-id="element-240">
                Es el sistema operativo completo que necesitás para llegar a
                cada consulta sabiendo exactamente qué preguntar, qué evaluar,
                qué plan diseñar, cómo comunicarlo y cómo cobrar lo que vale tu
                trabajo.
              </p>
            </div>
            <p className="text-brand-tealLight font-bold text-lg bg-white/10 p-4 rounded-lg text-center" data-id="element-241">
              Desde la primera consulta del lunes hasta el seguimiento del
              viernes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}